__turbopack_context__.v({
  "locate_content": "LocateFlow-module-scss-module__7r0iHq__locate_content",
});
